export interface UserLevel {
  id: number;
  name: string;
}

export enum UserLevelNames {
  Admin = 1,
}
